var map = {
	"./": 1800,
	"./adefault.module.scss": 6969,
	"./crickettimes.module.scss": 1446,
	"./index": 1800,
	"./index.js": 1800,
	"./meutimao.module.scss": 7493,
	"./pulzo.module.scss": 6836,
	"./superdeporte.module.scss": 2795,
	"./talksport.module.scss": 6235,
	"./thesun.module.scss": 1044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5162;